export const unsubscribeKeys = {
  all: ['unsubscribe'] as const,
  subscriptionState: (messageId: string) =>
    [...unsubscribeKeys.all, 'subscription-state', { messageId }] as const,
}
